module.exports = function(children) {
  return children.map(function(child) {
    return child.display_birthday
  }).join(', ')
}



// WEBPACK FOOTER //
// ./webroot/js/hbs_helpers/joinChildBirthday.js